// src/api/client.js
// Cliente HTTP base — wrapper sobre @leyro/api-client.
//
// B.1: 180 liñas de lóxica de tokens/refresh/erros foron extraídas a
// `@leyro/api-client` (paquete monorepo) para reutilizar a mesma
// lóxica desde mobile. Mantemos a interface pública (TokenStore + api)
// idéntica para non romper consumidores existentes.

import { createApiClient, createLocalStorageTokenStore, ApiError } from "@leyro/api-client";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000/api";

// ─── ALMACENAMENTO DE TOKENS ──────────────────────────────────────────────────
// Wrappamos o adapter base para incluír a limpeza extra de `ms_user`
// (perfil cacheado) que o app web usaba historicamente.
const baseStore = createLocalStorageTokenStore({
  accessKey: "ms_token",
  refreshKey: "ms_refresh_token",
});

export const TokenStore = {
  // API antiga: get() devolve access. getRefresh() devolve refresh.
  get: () => baseStore.getAccess(),
  getRefresh: () => baseStore.getRefresh(),
  set: (access, refresh) => baseStore.set(access, refresh),
  clear: () => {
    baseStore.clear();
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem("ms_user");
    }
  },
};

// ─── CLIENTE ──────────────────────────────────────────────────────────────────
// Inxección do TokenStore wrapper + callback ao caducar sesión.
const client = createApiClient({
  baseUrl: API_URL,
  tokenStore: {
    getAccess:  () => TokenStore.get(),
    getRefresh: () => TokenStore.getRefresh(),
    set:   (a, r) => TokenStore.set(a, r),
    clear: () => TokenStore.clear(),
  },
  onUnauthorized: () => {
    if (typeof window !== "undefined") {
      window.location.href = "/login";
    }
  },
});

// ─── HELPERS COMPATIBLES CON A API ANTIGA ─────────────────────────────────────
// Mesma signatura que o cliente anterior: api.get/post/put/patch/delete/upload/getBinary.
export const api = {
  get:    client.get,
  post:   client.post,
  put:    client.put,
  patch:  client.patch,
  delete: client.delete,
  upload: client.upload,
  getBinary: client.requestBinary,
};

// Re-export de utilidades para tratamento de erros nas páxinas se son útiles.
export { ApiError };
